/* eslint-disable */
import axios from 'axios'
import vm from '../main'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // api的base_url
  // timeout: 5000 // 请求超时时间
  timeout: 60 * 1000
})

// request拦截器
service.interceptors.request.use(config => {
  if (localStorage.token) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // config.timeout = 30000
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      if (response.status === 401) {
        vm.$message({
          message: 'Unauthorized!',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error('error'))
      }
      return Promise.reject(new Error('error'))
    } else {
      if (response.headers && response.headers.token) {
        localStorage.token = response.headers.token
      }
      return response.data
    }
  },
  err => {
    const response = err.response
    console.error(response)
    const status = response.status
    if (response && response.headers && response.headers.redirect) {
      localStorage.token = ''
      window.location.href = response.headers.redirect
    }
    if (status === 401 && window.location.hash.indexOf('/login') === -1) {
      localStorage.token = ''
      location.reload()
    }
    const data = response.data
    let message = undefined
    if (data) {
      if (typeof data === 'string') {
        message = data
      } else if (data.errorMessage) {
        message = data.errorMessage
      } else if (data.message) {
        message = data.message
      }
    }
    if (message === undefined) {
      message = 'Unknown Error'
    }
    vm.$message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(err)
  }
)

export default service
